import type { ReactNode } from 'react'
import { HorizontalStack } from '@ztechapps/webui.util'
import styles from './ComposerToolbarEnd.module.scss'

export type ComposerToolbarEndProps = { templateSelect: ReactNode; children: ReactNode }

export const ComposerToolbarEnd = ({ templateSelect, children }: ComposerToolbarEndProps) => {
  return (
    <HorizontalStack gap={1} className={`flex-wrap justify-content-end ${styles.toolbarEnd}`}>
      <div className={styles.templateSelect}>{templateSelect}</div>
      {children}
    </HorizontalStack>
  )
}
